var logpopup = document.getElementById('login-popup');
var regpopup = document.getElementById('register-popup');
var loginform = document.getElementById('login-form');
var recoverform = document.getElementById('recover-form');
document.addEventListener('DOMContentLoaded', () => {
  if(document.getElementById('acc-click')) document.getElementById('acc-click').addEventListener('click', (e) => {
    e.preventDefault();
    document.body.classList.toggle('active-popup');
    document.querySelector('body').classList.remove('scroll-down','scroll-up','open-search');
  });
  if(document.getElementById('drawer-acc')) document.getElementById('drawer-acc').addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.toggle('active-popup');
    document.querySelector('.snippet-menu-drawer').style.height = '';
  });
});
if(document.getElementById('register-first')) document.getElementById('register-first').addEventListener('click', function(e){
  e.preventDefault();
  regpopup.style.display = 'block'; 
  logpopup.style.display = 'none';
});
if(document.getElementById('login-second')) document.getElementById('login-second').addEventListener('click', function(e){
  e.preventDefault();
  logpopup.style.display = 'block'; 
  regpopup.style.display = 'none';
});
if(document.getElementById('forgot-password')) document.getElementById('forgot-password').addEventListener('click', function(e){
  e.preventDefault();
  recoverform.style.display = 'block'; 
  loginform.style.display = 'none';
});
if(document.getElementById('enable-login')) document.getElementById('enable-login').addEventListener('click', function(e){
  e.preventDefault();
  recoverform.style.display = 'none'; 
  loginform.style.display = 'block';
});
// Function to toggle password visibility
function togglePasswordVisibility(passwordSelector, iconSelector) {
  document.querySelectorAll(iconSelector).forEach(function(element) {
    element.addEventListener('click', function() {
      var passwordInput = this.parentElement.querySelector(passwordSelector);
      if (passwordInput.type === "password") {
        passwordInput.type = "text";
      } else {
        passwordInput.type = "password";
      }
    });
  });
}
togglePasswordVisibility('.display-pass', '.password-svg');
togglePasswordVisibility('.dis-reg-pass', '.reg-password-svg');

document.addEventListener('DOMContentLoaded', function () {
  function checkFields() {
    let fill = true;
    const inputs = document.querySelectorAll('#CustomerLogin input[type="email"], #CustomerLogin input[type="password"]');
    inputs.forEach(function (input) {
      if (input.value.trim() === '') {
        fill = false;
      }
    });
    document.getElementById('login-submit').disabled = !fill;
  }
  const inputElements = document.querySelectorAll('#CustomerLogin input[type="email"], #CustomerLogin input[type="password"]');
  inputElements.forEach(function (input) {
    input.addEventListener('input', checkFields);
  });
  checkFields(); 
});
document.addEventListener('DOMContentLoaded', function (){
  function checkFields() {
    let fill = true;
    const inputs = document.querySelectorAll('#recover_pass input[type="email"]');
    inputs.forEach(function (input) {
      if (input.value.trim() === '') {
        fill = false;
      }
    });
    document.getElementById('recover-sub').disabled = !fill;
  }
   const inputElements = document.querySelectorAll('#recover_pass input[type="email"]');
  inputElements.forEach(function (input) {
      input.addEventListener('input', checkFields);
  });
  checkFields(); 
});
// document.addEventListener('DOMContentLoaded', function (){
//   function checkregisterFields() {
//     let fill = true;
//     const inputfeilds = document.querySelectorAll('#CustomerRegister input[type="text"], #CustomerRegister input[type="email"], #CustomerRegister input[type="checkbox"], #CustomerRegister input[type="password"]');
//     inputfeilds.forEach(function (input) {
//       if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) {
//         fill = false;
//       } else if (input.type !== 'checkbox' && input.type !== 'radio' && input.value.trim() === '') {
//         fill = true;
//       }
//     });
//     document.getElementById('register-submit').disabled = !fill;
//     }
//     const inputElements = document.querySelectorAll('#CustomerRegister input[type="text"], #CustomerRegister input[type="email"], #CustomerRegister input[type="password"], #CustomerRegister input[type="checkbox"]');
//       inputElements.forEach(function (input) {
//       input.addEventListener('input', checkregisterFields);
//       input.addEventListener('change', checkregisterFields);
//     });
//     checkregisterFields(); 
// });
document.addEventListener('DOMContentLoaded', function () {
    function checkregisterFields() {
        let fill = true;
        const inputFields = document.querySelectorAll('#CustomerRegister input[type="text"], #CustomerRegister input[type="email"], #CustomerRegister input[type="password"]');
        const checkOne = document.getElementById('RegisterForm-Privacy');
        const checkTwo = document.getElementById('RegisterForm-exclusive-drop');

        // // Function to check if at least one checkbox is checked
        // function checkAtLeastOneChecked() {
        //     return checkOne.checked || checkTwo.checked;
        // }

        inputFields.forEach(function (input) {
            if (input.value.trim() === '') {
                fill = false;
            }
        });

        // if (!checkAtLeastOneChecked()) {
        //     fill = false;
        // }

        document.getElementById('register-submit').disabled = !fill;
    }

    const inputElements = document.querySelectorAll('#CustomerRegister input[type="text"], #CustomerRegister input[type="email"], #CustomerRegister input[type="password"]');
    inputElements.forEach(function (input) {
        input.addEventListener('input', checkregisterFields);
        input.addEventListener('change', checkregisterFields);
    });

    // const checkOne = document.getElementById('RegisterForm-Privacy');
    // const checkTwo = document.getElementById('RegisterForm-exclusive-drop');
    // checkOne.addEventListener('change', checkregisterFields);
    // checkTwo.addEventListener('change', checkregisterFields);

    checkregisterFields(); 
});
